import c from 'classnames';
import { Node } from 'prosemirror-model';
import { Decoration, DecorationSet } from 'prosemirror-view';

import { swatchStyles } from './styles';

const HEX_COLOR_REGEX = /(#[0-9a-f]{3,6})\b/gi;

export const findColors = (doc: Node): DecorationSet => {
  const decorations: Decoration[] = [];

  doc.descendants((node, position) => {
    if (!node.text) {
      return;
    }

    //using regex.exec() instead of matchAll beause matchAll is not supported by old browsers
    let match;
    while ((match = HEX_COLOR_REGEX.exec(node.text)) !== null) {
      const color = match[0];
      const index = match.index || 0;
      const from = position + index;
      const to = from + color.length;

      const decoration = Decoration.inline(from, to, {
        class: c('swatch-color', swatchStyles),
        style: `--swatch-color: ${color}`,
      });

      decorations.push(decoration);
    }
  });

  return DecorationSet.create(doc, decorations);
};
